import numUtils from "@/utils/numUtils";
import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import { getSettingData } from "@/api/http/gx/gxSetting";
import Http from "@/api/http/fetch/index";
import { judgeVersion } from "@/utils/judgeVersion";
import { getAppVersion, isIos } from "@/utils/lodash";
import { sendErrorEventToWindow } from "@/utils/analytics";
import store from "@/store";

const actions: ActionTree<any, any> = {
  async [types.REQUEST_GX_SETTING_DATA]({ state, commit, dispatch }) {
    try {
      const result = await Http.LoadSetting();
      if (!result) {
        return Promise.reject();
      }
      commit(types.RECEIVE_GX_SETTING_DATA, result);

      getSettingData()
        .then((setting: any) => {
          console.log("callback: ", setting);
          Http.SetSetting(setting).then(() => {
            // 成功拉取到线上setting并且注入到本地
            if (!store.state.startUpPolicyModule.settingExist) {
              store.state.startUpPolicyModule.settingExist = true;
            }

            if (isIos()) {
              Http.IapLocalizeUpdate().then((localPriceList: any) => {
                if (
                  localPriceList &&
                  !localPriceList.hasOwnProperty("status")
                ) {
                  for (const key in localPriceList) {
                    if (localPriceList.hasOwnProperty(key)) {
                      localPriceList[key].price = numUtils.toDecimal(
                        localPriceList[key].price
                      );
                    }
                  }
                  console.log("localPriceList:", localPriceList);
                  commit(types.UPDATE_LOCALIZE_PRICE, localPriceList);
                }
              });
            }
          });
          console.log("再次获取到setting:", setting);
          commit(types.RECEIVE_GX_SETTING_DATA, setting);
          //拉取superpay的配置: 推荐superpay的显示必须对应的参数才能显示，在拉到新的配置后再去初始化比较好，如果setting没拉到去初始化也是白搭
          dispatch(types.CHECK_SUPER_PAY_APP_CAN_SHOW); //suerp pay
          dispatch(types.CHECK_BACK_UP_APP_CAN_SHOW); //back up
          //更新本地文件：
          dispatch(types.UPDATE_LOCAL_FILES);
        })
        .catch((error: any) => {
          console.log("getSettingData error:", error);
        });
      console.log("REQUEST_GX_SETTING_DATA action:", result);
      return result;
    } catch (error) {
      console.log("REQUEST_GX_SETTING_DATA error:", error);
      sendErrorEventToWindow("get_setting_data_failed", error);
      return Promise.reject(error);
    }
  },
  async [types.UPDATE_INTERFACE_EXIST_STATE]({ state, commit, dispatch }) {
    try {
      const appInfo: any = await Http.AppInfo();
      const userAgent = getAppVersion();
      console.log("userAgent", userAgent);
      let versionNew: any = false;
      if (isIos()) {
        versionNew =
          appInfo &&
          appInfo.CODE_VERSION &&
          judgeVersion(appInfo.CODE_VERSION, "3.0.0");
      } else {
        versionNew = judgeVersion(userAgent, "4.0.0");
      }
      commit(types.UPDATE_INTERFACE_EXIST_STATE, versionNew);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.UPDATE_CRUCIAL_SETTING_KEY](
    { state, commit, dispatch },
    payload: any
  ) {
    try {
      //更新关键字段: double coins, half price:
      console.log("UPDATE_CRUCIAL_SETTING_KEY:", {
        new: payload,
        old: state.settingData
      });
      const { coin_limit_sale, coin_half_sale } = payload;
      const { settingData } = state;
      coin_limit_sale
        ? (settingData.coin_limit_sale = coin_limit_sale)
        : void 0;
      coin_half_sale ? (settingData.coin_half_sale = coin_half_sale) : void 0;
    } catch (error) {}
  }
};

export default actions;
